 import Http from '../../common/services/Http';
 import { RuleDto } from './models/RuleDto';

class RuleService {

    public getAllForCompany(getDescriptions?:boolean,companyId?:string) {
        return Http.get<RuleDto[]>(`rules` ,{ getDescriptions: getDescriptions ?? false ,companyId });
    }

    public update(model: RuleDto[],saveDescriptions:boolean,companyId?:string) {
        return Http.put('rules', { rules : model ,saveDescriptions,companyId });
    }

}

export default new RuleService();